import React, { Component, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { Link } from "react-router-dom";
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import { Key, Thunderbolt, Tree } from 'react-bootstrap-icons';

export class MHEWithPickRows extends Component {
    static displayName = MHEWithPickRows.name;
    constructor(props) {
        super(props);
        this.state = {
            loading: false, mheWithPickRows: [], alertMessage: "", selectedPick: props.location.state.selectedPick, pickDirection: 1, pickCompleteError: false
        };
        this.history = props.history;

    }
    componentDidMount() {
        this.getMHEWithPickList();

    }
    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    render() {
        var pickNumber = this.state.selectedPick.pickNumber;
        var pickOptions = {
            preventShortPick: this.state.selectedPick.prevent_Short_Picks,
            preventAlternateGrade: this.state.selectedPick.prevent_Alt_Grades,
            barcodeScanRequirement: this.state.selectedPick.productBarcodeRequirement,
            isGS1: this.state.selectedPick.isGS1,
            nameCode: this.state.selectedPick.nameCode
        };

        if (this.state.loading === true) {
            return <em>Loading picks</em>
        }
        var parent = this;
        return (
            <div>
                <Button variant="link" onClick={() => this.goto('ActivePicks', { nameCode: this.state.selectedPick.nameCode })}>&lt;- back to Pick List </Button>
                <h4>Pick Number: {pickNumber}</h4>
                <h5>Picks By MHE Type</h5>
                {this.state.alertMessage.length > 0 &&
                    <MyAlert variant="danger">{this.state.alertMessage}</MyAlert>
                }
                {!this.state.loading && this.state.mheWithPickRows.map(function (item) {
                    item.currentPickDirection = 1;
                    var child = parent;
                    return (

                        <div key={item.mheName}>
                            <Card className="mb-1" >
                                <Card.Header>
                                    {item.mheName}
                                </Card.Header  >
                                <Card.Body>
                                    {
                                        item.listType === -1 && <MyAlert variant="danger">This pick is now on hold, please see pick supervisor</MyAlert>
                                    }
                                    <div>
                                        <Form>
                                            <Form.Label>Pick Direction</Form.Label>
                                            {['radio'].map((type) => (
                                                <div key={`inline-${type}`} className="mb-3">
                                                    <Form.Check
                                                        inline
                                                        label="1 -> 9"
                                                        name="group1"
                                                        type={type}
                                                        id={`inline-${type}-1`}
                                                        value={1}
                                                        onChange={(e) => { child.setState({ pickDirection: parseInt(e.target.value) }) }}
                                                        checked
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="9 -> 1"
                                                        name="group1"
                                                        type={type}
                                                        id={`inline-${type}-2`}
                                                        value={-1}
                                                        onChange={(e) => { child.setState({ pickDirection: parseInt(e.target.value) }) }}

                                                    />
                                                </div>
                                            ))}
                                        </Form>
                                        <Table responsive>
                                            <thead>
                                                <tr>
                                                    <td>Row</td>
                                                    <td>Locations</td>
                                                    <td>Sku</td>
                                                    <td>Units</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {item.pickRows.map((element, index) => (
                                                    <tr key={element.rowName}>
                                                        <td>{element.rowName}</td>
                                                        <td>{element.loc_Count}</td>
                                                        <td>{element.product_Count}</td>
                                                        <td>{element.unit_Sum}</td>
                                                        <td>
                                                            <Button variant="success" onClick={() => child.goto('PickLocation', { pickNumber: pickNumber, mheId: item.mheid, rowName: element.rowName, pickDirection: child.state.pickDirection, pickOptions: pickOptions, selectedPickInfo: child.state.selectedPick })}>Pick</Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    );
                })}
                {this.state.pickCompleteError && <Button variant="success" onClick={() => this.goto("ChoosePick", {})}>Back to Pick List</Button>}

            </div>
        );
    }

    async getMHEWithPickList() {
        this.setState({ loading: true });
        fetch(`api/PaperlessPicking/GetMHEWithPickRows?pickNumber=${this.state.selectedPick.pickNumber}`)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    this.setState({ alertMessage: result.errorMessage, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, mheWithPickRows: result.data, alertMessage: "" });
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                        var pickOptions = {
                            preventShortPick: this.state.selectedPick.prevent_Short_Picks,
                            preventAlternateGrade: this.state.selectedPick.prevent_Alt_Grades,
                            barcodeScanRequirement: this.state.selectedPick.productBarcodeRequirement,
                            isGS1: this.state.selectedPick.isGS1,
                            nameCode: this.state.selectedPick.nameCode
                        };

                        if (result.data == "PickCompleted") {
                            //const timer = setTimeout(() => {
                            //    this.goto("ChoosePick", {});
                            //}, 3000);
                            this.setState({ pickCompleteError: true })
                        }

                        if (result.data == "ShortedPick") {
                            const timer = setTimeout(() => {
                                this.goto('ShortedProducts', { selectedPick: this.state.selectedPick, pickOptions: pickOptions });
                            }, 3000);
                        }                       

                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false, alertMessage: "OOOps an error occurred. Please try again!!!" });
            })

    }

}
export default MHEWithPickRows;

